<template>
  <div :class="{ 'form-group': !row, 'form-row': row }">
    <label v-if="label" :class="getLabelClass" :for="labelFor">
      {{ label }}
      <span v-if="mandatory" class="text-danger">*</span>
      <template v-if="tooltip">
        <div v-tooltip="tooltip" class="label-tooltip">
          <base-icon icon="info" />
        </div>
      </template>
    </label>
    <div :class="wrapClass">
      <div :class="getAddonClasses">
        <div v-if="hasAddonLeft" class="input-group-prepend">
          <div v-if="addonLeft || addonLeftIcon" class="input-group-text">
            <template v-if="addonLeftIcon">
              <base-icon :icon="addonLeftIcon" />
            </template>
            <template v-else>
              {{ addonLeft }}
            </template>
          </div>
          <slot name="addonLeft" />
        </div>
        <slot />
        <div v-if="hasAddonRight" class="input-group-append">
          <div v-if="addonRight || addonRightIcon" class="input-group-text">
            <template v-if="addonRightIcon">
              <base-icon :icon="addonRightIcon" />
            </template>
            <template v-else>
              {{ addonRight }}
            </template>
          </div>
          <slot name="addonRight" />
        </div>
      </div>
      <div v-if="feedback" :class="{ 'invalid-feedback': isInvalid, 'valid-feedback': isValid }">
        {{ feedback }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLabel',

  props: {
    addonLeft: String,
    addonLeftIcon: String,
    addonRight: String,
    addonRightIcon: String,
    feedback: String,
    isInvalid: Boolean,
    isValid: Boolean,
    label: String,
    labelClass: String,
    labelFor: String,
    large: Boolean,
    mandatory: Boolean,
    row: Boolean,
    small: Boolean,
    tooltip: String,
    wrapClass: String
  },

  computed: {
    getAddonClasses () {
      const classes = []

      if (this.hasAddon) {
        classes.push('input-group')

        if (this.large) {
          classes.push('input-group-lg')
        }

        if (this.small) {
          classes.push('input-group-sm')
        }
      }

      return classes.join(' ')
    },

    getLabelClass () {
      if (this.isInvalid) {
        return this.labelClass + ' text-danger'
      }

      return this.labelClass
    },

    hasAddon () {
      return this.hasAddonLeft || this.hasAddonRight
    },

    hasAddonLeft () {
      return this.$slots.addonLeft || this.addonLeft || this.addonLeftIcon
    },

    hasAddonRight () {
      return this.$slots.addonRight || this.addonRight || this.addonRightIcon
    }
  }
}
</script>
